export const addDelegatedEventListener = (el: HTMLElement, eventName: string, selector: string, handler: any) => {
    el.addEventListener(eventName, function (e: Event) {
        for (let target: any = e.target; target && target !== this; target = target.parentNode) {
            if (target.matches(selector)) {
                handler.call(target, e);
                break;
            }
        }
    }, false);
};